import useFilteredItems from '../../model/hooks/useFilteredItems';
import LaRocheCorner from '../LaRocheCorner/LaRocheCorner';
import AreaWrapper from '../AreaWrapper/AreaWrapper';
import Images from '../Images/Images';
import Items from '../Items/Items';
import ShadowSpace from '../shadowSpace/ShadowSpace';

export default function Area() {
  const items = useFilteredItems();

  return (
    <AreaWrapper>
      {(bounding, animatedDrag, offsetData, moveStyles) => {
        const fullProps = { items, animatedDrag, offsetData, bounding, moveStyles, ...arguments[0] };
        return (
          <>
            <Images />
            <div className={'interactive-shop__items'}>
              <Items {...fullProps} />
              <LaRocheCorner {...fullProps} />
            </div>
            <ShadowSpace {...fullProps} />
          </>
        );
      }}
    </AreaWrapper>
  );
}
